<template>
  <el-dialog title="支付记录" :visible.sync="isShow" width="80%">
    <section v-loading="listLoading" class="page-container">
      <!--工具条-->
      <div ref="toolbar" class="toolbar">
        <el-form :inline="true" :model="filters">
          <el-form-item>
            <el-input v-model="filters.userId" placeholder="用户ID"></el-input>
          </el-form-item>
          <el-form-item>
            <el-select v-model="filters.payMethod" clearable placeholder="支付方式" @change="list">
              <el-option value="GCASH"></el-option>
              <el-option value="PAYPAL"></el-option>
              <el-option value="CASH"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select v-model="filters.payStatus" clearable placeholder="支付状态" @change="list">
              <el-option
                v-for="(value, key) in payStatus"
                :key="key"
                :value="key"
                :label="value"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="list">查询</el-button>
          </el-form-item>
        </el-form>
      </div>

      <!--列表-->
      <div ref="mainContent" :style="{ height: mainHeight }">
        <payment-order-table :results="results" />
      </div>

      <!-- 分页 -->
      <my-pagination
        ref="pagebar"
        :page="page"
        @current-change="handlePageChange"
        @size-change="handleLimitChange"
      />
    </section>
  </el-dialog>
</template>

<script>
import PaymentOrderTable from "./PaymentOrderTable";
import MyPagination from "@/components/MyPagination";
// import mainHeight from "@/utils/mainHeight";
export default {
  name: "PaymentOrder",
  components: { MyPagination, PaymentOrderTable },
  data() {
    return {
      mainHeight: "300px",
      results: [],
      listLoading: false,
      page: {},
      filters: {},
      selectedRows: [],

      isShow: false,

      orderType: {
        BUYER_ORDER: "买家订单",
        BUYER_BALANCE_ORDER: "买家求购支付尾款",
        SELLER_ORDER: "卖家订单",
      },
      payStatus: {
        0: "未支付",
        1: "已支付",
      },
    };
  },
  mounted() {
    // mainHeight(this);
  },
  methods: {
    async show(orderType, orderId) {
      this.isShow = true;
      this.filters.bizType = orderType;
      this.filters.bizId = orderId;
      await this.list();
    },
    async list() {
      this.listLoading = true;
      const params = Object.assign(this.filters, {
        page: this.page.page,
        limit: this.page.limit,
      });
      try {
        this.results = [];
        const data = await this.axios.form("mall:/api/admin/payment-order/list", params);
        this.results = data.results;
        this.page = data.page;
      } catch (e) {
        this.$notify.error({ title: "错误", message: e.message || e });
      } finally {
        this.listLoading = false;
      }
    },
    handleCommand(cmd) {
      switch (cmd.type) {
        case "edit":
          this.handleEdit(cmd.index, cmd.data);
          break;
        case "delete":
          this.deleteSubmit(cmd.index, cmd.data);
          break;
        default:
          break;
      }
    },
    async handlePageChange(val) {
      this.page.page = val;
      await this.list();
    },
    async handleLimitChange(val) {
      this.page.limit = val;
      await this.list();
    },
  },
};
</script>

<style lang="scss" scoped></style>
